import React from 'react';

export const Home = React.lazy(() => import('../containers/Home/Home'));
export const ImagesList = React.lazy(() => import('../containers/ImagesList/ImagesList'));
export const PhotgrapherProfile = React.lazy(() => import('../containers/PhotgrapherProfile/PhotgrapherProfile'));
export const NotFound = React.lazy(() => import('../components/NotFound/NotFound'));